import { render, staticRenderFns } from "./ReviewDependencyComponent.vue?vue&type=template&id=5cc0c85f&scoped=true&"
import script from "./ReviewDependencyComponent.vue?vue&type=script&lang=js&"
export * from "./ReviewDependencyComponent.vue?vue&type=script&lang=js&"
import style0 from "./ReviewDependencyComponent.vue?vue&type=style&index=0&id=5cc0c85f&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cc0c85f",
  null
  
)

export default component.exports